exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*.advocateDetailsDiv {\r\n  background-color: #D8E6E7;\r\n  padding: 2em;\r\n}\r\n\r\n.advocateAddressDiv {\r\n  font-weight: bold;\r\n  padding-bottom: 1em;\r\n}\r\n\r\n.advocateAddressLbl {\r\n  margin-bottom: 1.8em\r\n}\r\n\r\n.advocateFileDiv {\r\n  margin-top: 2em;\r\n  margin-bottom: 1em;\r\n}\r\n\r\n.powerOfAttorneyStar {\r\n  color:red;\r\n}*/\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/Develop/MOH.Gazezet/Dev/MOH.Gazzezet/MOH.Gazzezet/src/app/components/worsening/worsening-advocate/worsening-advocate.component.scss
// module id = ../../../../../src/app/components/worsening/worsening-advocate/worsening-advocate.component.scss
// module chunks = main